import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FrameType_BINARY_getInstancehqo9wx0a59wp as FrameType_BINARY_getInstance,
  FrameType_TEXT_getInstance11g351zf7qqsw as FrameType_TEXT_getInstance,
  FrameType_CLOSE_getInstance2i97v6b946tow as FrameType_CLOSE_getInstance,
  FrameType_PING_getInstance24o4imr7pra4 as FrameType_PING_getInstance,
  FrameType_PONG_getInstance3un078qabuf1n as FrameType_PONG_getInstance,
} from './FrameType.mjs';
import { NonDisposableHandle_instance20n9avbwze9pj as NonDisposableHandle_instance } from './FrameCommon.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  writeText19qfzm98fbm4l as writeText,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.s5e(fin, data, rsv1, rsv2, rsv3);
      }
      static s5e(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.t5e(fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static u5e(fin, data) {
        return this.s5e(fin, data, false, false, false);
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.c5f(fin, data, rsv1, rsv2, rsv3);
      }
      static c5f(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.t5e(fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static d5f(fin, data) {
        return this.c5f(fin, data, false, false, false);
      }
      static e5f(text) {
        return this.d5f(true, toByteArray(text));
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var CloseClass;
function Close() {
  if (CloseClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.f5f(data);
      }
      static f5f(data) {
        return this.t5e(true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
      static d5c(reason) {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        var builder = new (Buffer())();
        builder.a4h(reason.u5a_1);
        writeText(builder, reason.v5a_1);
        return this.g5f(builder);
      }
      static g5f(packet) {
        return this.f5f(readByteArray(packet));
      }
      static h5f() {
        return this.f5f(Companion_getInstance().b5d_1);
      }
    }
    initMetadataForClass($, 'Close', $.h5f);
    CloseClass = $;
  }
  return CloseClass;
}
var PingClass;
function Ping() {
  if (PingClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.q5d(data);
      }
      static q5d(data) {
        return this.t5e(true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
    }
    initMetadataForClass($, 'Ping');
    PingClass = $;
  }
  return PingClass;
}
var PongClass;
function Pong() {
  if (PongClass === VOID) {
    class $ extends Frame() {
      constructor(data, disposableHandle) {
        return new.target.a5d(data, disposableHandle);
      }
      static a5d(data, disposableHandle) {
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        return this.t5e(true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
      }
    }
    initMetadataForClass($, 'Pong');
    PongClass = $;
  }
  return PongClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.b5d_1 = new Int8Array(0);
      }
      c5d(fin, frameType, data, rsv1, rsv2, rsv3) {
        var tmp;
        switch (frameType.w1_1) {
          case 1:
            tmp = Binary().s5e(fin, data, rsv1, rsv2, rsv3);
            break;
          case 0:
            tmp = Text().c5f(fin, data, rsv1, rsv2, rsv3);
            break;
          case 2:
            tmp = Close().f5f(data);
            break;
          case 3:
            tmp = Ping().q5d(data);
            break;
          case 4:
            tmp = Pong().a5d(data, NonDisposableHandle_instance);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      static t5e(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        var $this = createThis(this);
        $this.f5c_1 = fin;
        $this.g5c_1 = frameType;
        $this.h5c_1 = data;
        $this.i5c_1 = disposableHandle;
        $this.j5c_1 = rsv1;
        $this.k5c_1 = rsv2;
        $this.l5c_1 = rsv3;
        return $this;
      }
      toString() {
        return 'Frame ' + this.g5c_1.toString() + ' (fin=' + this.f5c_1 + ', buffer len = ' + this.h5c_1.length + ')';
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance31awdom2j9aye,
  Binary as Binary3tlzyfojm51s4,
  Close as Close3tx65evcwi73t,
  Ping as Ping3nta6l7sdq1r9,
  Pong as Pong3m3cas9hmc9ec,
  Text as Text3e6ukp9joohql,
};
//endregion

//# sourceMappingURL=Frame.web.mjs.map
